/** Sesión de edición a medias: el dashboard pregunta antes de salir. */

export function isSessionDirty(session) {
  if (!session) return false;
  const d = session.dirty;
  return typeof d === 'function' ? Boolean(d()) : Boolean(d);
}

export function sessionMessage(session, fallback = '') {
  if (!session) return fallback;
  const m = session.message;
  const text = typeof m === 'function' ? m() : m;
  return String(text || fallback);
}

/**
 * Elige la sesión que bloquea la salida.
 * Prefiere una sucia; si no hay cambios, cualquier sesión activa (editor abierto).
 */
export function pickBlockingSession(sessions) {
  const list = (sessions || []).filter(Boolean);
  if (!list.length) return null;
  return list.find((s) => isSessionDirty(s)) || list[0];
}
